import Avatar from '@/components/base/Avatar';
import StatusBadge from '@/components/base/StatusBadge';
import { formatMoney } from '@/utils/format';
import { channelMeta } from '@/utils/payment';
import type { SinglePayment } from '@/types/portal';

interface RecentSinglePaymentsProps {
  payments: SinglePayment[];
}

export default function RecentSinglePayments({ payments }: RecentSinglePaymentsProps) {
  return (
    <section className="rounded-lg border border-background-200 bg-background-50">
      <header className="flex items-center justify-between gap-2 border-b border-background-200 px-5 py-4">
        <div>
          <h3 className="font-heading text-sm font-semibold text-foreground-950">
            Recent single payments
          </h3>
          <p className="mt-0.5 text-xs text-foreground-500">
            One-off settlements sent from here
          </p>
        </div>
        <span className="flex h-8 w-8 items-center justify-center rounded-md bg-background-200 text-base text-foreground-600">
          <i className="ri-history-line" />
        </span>
      </header>

      <ul className="divide-y divide-background-100">
        {payments.slice(0, 5).map((payment) => (
          <li key={payment.id} className="flex items-center gap-3 px-5 py-3.5">
            <Avatar src={payment.avatar} alt={payment.payeeName} size="sm" />
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-2">
                <p className="truncate text-sm font-medium text-foreground-950">
                  {payment.payeeName}
                </p>
                <span className="inline-flex items-center gap-1 rounded-full bg-background-200 px-1.5 py-0.5 text-[10px] font-label font-medium text-foreground-600">
                  <i className={channelMeta[payment.channel].icon} />
                  {channelMeta[payment.channel].short}
                </span>
              </div>
              <p className="truncate text-xs text-foreground-500">
                {payment.reference} · {payment.target} · {payment.createdAt}
              </p>
            </div>
            <div className="flex shrink-0 flex-col items-end gap-1">
              <span className="text-sm text-foreground-900">
                {formatMoney(payment.amount, payment.currency)}
              </span>
              <StatusBadge status={payment.status} />
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}